import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-top-consumed-products-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './top-consumed-products-chart.component.html',
  styleUrl: './top-consumed-products-chart.component.scss'
})
export class TopConsumedProductsChartComponent implements AfterViewInit, OnChanges {
  @Input() isLoadingTopConsumedProducts: boolean = false;
  @Input() topConsumedProductsData: any = null;
  @ViewChild('chart2', { static: false }) chart2!: ElementRef<HTMLCanvasElement>;
  private chartInstance: any;

  ngAfterViewInit() {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['topConsumedProductsData'] && !changes['topConsumedProductsData'].firstChange) {
      this.renderChart();
    }
  }

  renderChart() {
    if (!this.topConsumedProductsData || !this.chart2) return;
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    let labels = this.topConsumedProductsData.products?.map((p: any) => p.product_name) || [];
    let data = this.topConsumedProductsData.products?.map((p: any) => p.count) || [];
    const othersCount = this.topConsumedProductsData.others_count || 0;

    if (othersCount > 0) {
      labels = [...labels, 'Others'];
      data = [...data, othersCount];
    }
    const baseColors = [
      '#2196F3', // blue
      '#4CAF50', // green
      '#FF9800', // orange
      '#F44336', // red
      '#FFEB3B'  // yellow
    ];
    const othersColor = '#9C27B0'; // purple for 'Others'

    let backgroundColors = baseColors.slice(0, labels.length);
    if (labels[labels.length - 1] === 'Others') {
      backgroundColors[labels.length - 1] = othersColor;
    }
    this.chartInstance = new Chart(this.chart2.nativeElement, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Consumed',
          data: data,
          backgroundColor: backgroundColors,
          borderRadius: 8,
          maxBarThickness: 32
        }]
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        plugins: {
          legend: { display: false }
        },
        scales: {
          x: { beginAtZero: true }
        }
      }
    });
  }
}
